import React, { useEffect, useState } from "react";
import {  Row, Col, CreditCardInputUtils, HeadingText, CaptionText, BodyText, LoadingSpinner, ContextualAlert,Card } from "@paypalcorp/pp-react";
import { fetchResponse } from "../../common/serviceRequest";
import { get } from "lodash";
import * as FPT from "../../utility/fpt";
import { hide } from "../../common/domUtils";
import withTheme from "../../common/withTheme";
const PPGFSummaryTotal = (props) => {
  const [completedPayoutLoader, setCompletedPayoutLoader] = useState(true);
  const [pendingPayoutLoader, setPendingPayoutLoader] = useState(true);
  const [completedPayoutTotal, setCompletedPayoutTotal] = useState("");
  const [completedPayoutTotalError, setCompletedPayoutTotalError] = useState(false);
  const [pendingPayoutTotalAmount, setPendingPayoutTotalAmount] = useState("");
  const [pendingPayoutTotalError, setPendingPayoutTotalError] = useState(false);

  useEffect(() => {
  
    // Get Current Year Payout Total
    fetchResponse("/givingfund/currentYearPaidOutTotal", "GET", null)
      .then(function (result) {
        setCompletedPayoutLoader(false);
        if (result.status != "error") {
          setCompletedPayoutTotal(
            get(result, "data.totalPayout.total_amount", "")
          );
        } else {
          throw new Error();
        }
      })
      .catch(function () {
        hide(".completedPayoutTxt");
        setCompletedPayoutTotalError(true);
      });

    // Get Pending Donations Total
    fetchResponse("/givingfund/pendingDonationsTotal", "GET", null)
      .then(function (result) {
        setPendingPayoutLoader(false);
        if (result.status != "error") {
          setPendingPayoutTotalAmount(get(result, "data.total_amount", ""));
        } else {
          throw new Error();
        }
      })
      .catch(function () {
        hide(".pendingPayoutTxt");
        setPendingPayoutTotalError(true);
      });
  }, []);

  return (
    
      <Row>
        <Col md="auto">
          <Card id="completedPayouts" className={`transactionTabs ${props.completedPayout && "currentPayoutTab"}`} style={{ cursor: "pointer", paddingRight: "100px" }} onClick={() => props.handlePayoutSummary("completedPayouts")}>
            <BodyText style={{ color: "#515354" }}>
              {props.dashboardPageMsg.dashboard.compeletedPayoutTxt}
            </BodyText>
            {completedPayoutTotalError && (
              <ContextualAlert type="error">
                {props.dashboardPageMsg.dashboard.totalErr}
              </ContextualAlert>
            )}
            <HeadingText size="lg" style={{ margin: "12px 0", color: props.completedPayout && "#1040c1" }}>
              {completedPayoutLoader ?
                <LoadingSpinner size="md" screenReaderText={props.dashboardPageMsg.dashboard.loadingCurrentYearTotal} />
                :
                `${completedPayoutTotal}`
              }
            </HeadingText>
            {!completedPayoutTotalError &&
              <CaptionText style={{ color: "#515354" }}>
                {props.dashboardPageMsg.dashboard.compeletedPayoutDesc}
              </CaptionText>
            }
          </Card>
        </Col>
        <Col md="auto">
          <Card id="pendingPayouts" className={`transactionTabs ${!props.completedPayout && "currentPayoutTab"}`} style={{ cursor: "pointer", paddingRight: "100px" }} onClick={() => props.handlePayoutSummary("pendingPayouts")}>
            <BodyText style={{ color: "#515354" }}>
              {props.dashboardPageMsg.dashboard.pendingPayoutTxt}
            </BodyText>
            {pendingPayoutTotalError && (
              <ContextualAlert type="error">
                {props.dashboardPageMsg.dashboard.totalErr}
              </ContextualAlert>
            )}
            <HeadingText size="lg" style={{ margin: "12px 0", color: !props.completedPayout && '#1040c1' }}>
              {pendingPayoutLoader ?
                <LoadingSpinner size="md" screenReaderText={props.dashboardPageMsg.dashboard.loadingPDTotal} />
                :
                `${pendingPayoutTotalAmount}`
              }
            </HeadingText>
          </Card>
        </Col>
      </Row>
    
  );
};
export default withTheme(PPGFSummaryTotal);
